export const DISBURSEMENT_TARGET = { DRAW: "DRAW", USE_OF_FUND: "USE_OF_FUND" };
